<template>
  <v-card class="elevation-12" :loading="loading" :disabled="loading">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>MarketPro</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-alert v-if="error" type="error">{{error}}</v-alert>
      <v-form @keyup.native.enter="login()">
        <v-text-field
          label="Email"
          name="email"
          prepend-icon="mdi-account"
          type="text"
          v-model="credential.email"
        />

        <v-text-field
          id="password"
          label="Mot de passe"
          name="password"
          prepend-icon="mdi-lock"
          type="password"
          v-model="credential.password"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" @click.stop="login()">Connexion</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    credential: {
      email: null,
      password: null
    },
    error: null
  }),
  computed: {
    ...mapGetters("auth", ["loading"])
  },
  methods: {
    login: function() {
      this.error = null;
      this.$store
        .dispatch("auth/login", this.credential)
        .then(() => this.$router.push({ name: "Home" }))
        .catch(() => {
          this.error = "Email ou Mot de passe incorrect";
        });
    }
  }
};
</script>

<style>
</style>